import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';

const OPERATOR_OPTIONS = [
    { value: 'EQ', imagePath: '/images/block/comparison_eq.svg', tooltip: '等しい [==]' },
    { value: 'NEQ', imagePath: '/images/block/comparison_neq.svg', tooltip: '等しくない [!=]' },
];

defineBlock({
    type: 'comparison_string',
    colour: CATEGORIES.operator.color,
    tooltip: '2つの文字列を比較します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Boolean',
    inputs: [
        {
            kind: 'value',
            name: 'A',
            check: 'String',
            shadow: { type: 'string', fields: { TEXT: '' } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'OP',
                    instance: () => new FieldOperatorDropdown(OPERATOR_OPTIONS),
                },
            ],
        },
        {
            kind: 'value',
            name: 'B',
            check: 'String',
            shadow: { type: 'string', fields: { TEXT: '' } },
        },
    ],
});
